'use client'

import { useTranslations } from 'next-intl'
import Link from 'next/link'
import InfoCard from './info-card'
import SectionHeader from './section-header'

export default function CompanyCulture() {
  const t = useTranslations('page_cam_ket_phat_trien')
  return (
    <div id='item-4-content'>
      <SectionHeader number='04' title={t('culture.title')} />
      <div className='grid gap-5 md:grid-cols-2'>
        <InfoCard
          imageSrc='https://media.coolmate.me/image/October2024/mceclip5_38.png'
          imageAlt={t('culture.card_1.alt')}
          title={t('culture.card_1.title')}
          description={t('culture.card_1.description')}
        />
        <InfoCard
          imageSrc='https://media.coolmate.me/image/October2024/mceclip4_90.png'
          imageAlt={t('culture.card_2.alt')}
          title={
            <Link
              href='/collection/care-and-share/'
              className='mb-3 inline-flex items-center gap-1 font-criteria text-lg font-medium text-primary md:text-xl'
            >
              {t('culture.card_2.title')} <span>↗</span>
            </Link>
          }
          description={
            <>
              {t('culture.card_2.description_prefix')}{' '}
              <Link
                href='/post/careshare-cung-operation-smile-viet-nam-mang-lai-nu-cuoi-cho-cac-em-1222'
                className='font-bold text-primary underline'
              >
                {t('culture.card_2.link_text')}
              </Link>
              {t('culture.card_2.description_suffix')}
            </>
          }
        />
      </div>
    </div>
  )
}
